<template>
    <div class="receiveRange-page" :style="{ minHeight: noHead === 'true' ? '100%' : '60%' }">
        <div class="address">
            <div class="address-wrap" @click="selectAddress">
                <div class="holder">查询地区</div>
                <div class="area" :class="{ active: addr.length }">
                    {{ addr.length ? showAddr : '国家/地区选择' }}
                </div>
                <div class="ico">
                    <icon class="ico-right" name="right"></icon>
                </div>
            </div>
            <div v-show="tabCode === 'ibu'" class="address-wrap">
                <div class="holder">邮政编码</div>
                <input v-model="ibuPostalCode" type="text" placeholder="请输入邮政编码" />
                <div class="ico">
                    <icon class="ico-right" name="right"></icon>
                </div>
            </div>
        </div>
        <p class="button-wrapper">
            <button type="button" class="primary-btn" :disabled="!addr.length" @click="query">查询</button>
        </p>
        <!-- <div class="warn-tip">【温馨提醒】：受疫情影响部分地区网点收派件受限，受限地区请以实际下单提示为准。</div> -->
        <div v-show="isShowResult" class="result">
            <div class="result-item">
                <div class="result-area red">{{ tabCode === 'ibu' ? showIbuAddr : showAddr }}</div>
                <div class="result-desc">{{ resultRange }}</div>
                <div v-if="unavailableRegions.length" class="result-desc">
                    {{ showUnavailableRegions }}
                </div>
                <div v-if="isShowHKAreaTip" class="result-desc supplement">
                    <p>特别说明：</p>
                    <p>南丫岛、长洲及坪洲区，每票限重30KG。</p>
                </div>
                <div v-if="isShowTibetTip" class="result-desc red">
                    <p>温馨提示：港澳台地区与西藏自治区互寄业务暂未开通。</p>
                </div>
                <div v-if="isShowTWTip" class="result-desc supplement">
                    备注：2019/10/1起台湾宅配件暂停收送离岛件服务，区域包含金门、澎湖、妈祖、绿岛、蓝屿、小琉球。详情派件服务范围请洽客服专线412-8830(手机请加02)。
                </div>
            </div>
        </div>
        <area-selector
            :isShow="showAreaSelector"
            :tabCode="tabCode"
            :title="areaSelectorTitle"
            :areaTypeList="areaTypeList"
            :area="addr"
            @closeAreaSelector="closeAreaSelector"
            @confirm="confirm"
        ></area-selector>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
import ajax from '@/api/ajax'
import areaSelector from '@/components/areaSelector/index'
import { areaTypeMap } from '@/components/areaSelector/config'
import { regionRangeMap } from './config'
import { COUNTRY_CODE } from '@uip-alpha/business-constants'

export default {
    name: 'ReceiveRange',
    components: {
        'area-selector': areaSelector
    },
    props: {
        // 是否隐藏头部
        noHead: {
            type: String,
            default: 'false'
        },
        // 是否隐藏寄件
        noShip: {
            type: String,
            default: 'false'
        },
        noFooter: {
            type: String,
            default: 'false'
        }
    },
    data() {
        return {
            areaTypeMap,
            showAreaSelector: false, // 控制地址选择器显示
            tabCode: '', // tabCode
            areaSelectorTitle: '地区选择', // 地址选择器标题
            areaTypeList: [areaTypeMap.cn, areaTypeMap.hmt, areaTypeMap.ibu], // 需要地址选择器提供的地址选择种类
            addr: [], // 地区
            resultRange: '', // 展示的范围查询
            unavailableRegions: [], // 不可配送的地区
            ibuPostalCode: '', // 国际邮政编码
            isShowResult: false, // 是否显示结果
            showIbuAddr: '' // 显示的国际地区
        }
    },
    computed: {
        showAddr() {
            return this.addr.map(item => item.name).join('-')
        },
        showUnavailableRegions() {
            return `不服务的地区为：${this.unavailableRegions.map(item => item.name).join('、')}`
        },
        isShowHKAreaTip() {
            return this.addr.length && this.addr[0].code === COUNTRY_CODE.HK && ['A000864000', 'A000844000', 'A000845000'].includes(this.addr[1].code)
        },
        isShowTibetTip() {
            return this.addr.length && this.addr[0].code.slice(0, 3) === 'A54'
        },
        isShowTWTip() {
            return this.addr.length && this.addr[0].code === COUNTRY_CODE.TW
        }
    },
    created() {
        this.setTitle('收寄范围查询')
        this.setShowHeader(!(this.noHead === 'true'))
        this.setShowFooter(!(this.noFooter === 'true'))
        this.$addCBGReport('receive-range-visit', '收寄范围查询访问埋点')
    },
    methods: {
        // 点击查询
        async query() {
            if (!this.addr.length) {
                return
            }
            this.unavailableRegions = []
            this.tabCode === 'ibu' ? this.queryIbu() : this.queryInternal()
        },
        // 查询国际收寄范围
        async queryIbu() {
            if (!this.ibuPostalCode) {
                return this.$toast('请输入邮政编码')
            }
            let res = await this.queryPostCodeInfo(this.addr[0], this.ibuPostalCode)
            res = res.result
            if (res.result && res.result.length > 0) {
                const status = res.result[0] && res.result[0].status
                if (status === 1) {
                    this.resultRange = '该地区可达'
                } else {
                    if (status === 0) {
                        this.resultRange = res.msg || '该地区不可达'
                    } else {
                        this.resultRange = res.msg || '未找到该邮编配送信息，请确认邮编或致电客服中心'
                    }
                }
            } else {
                this.resultRange = res.msg || '未找到该邮编配送信息，请确认邮编或致电客服中心'
            }
            this.showIbuAddr = `${this.addr[0].name} - ${this.ibuPostalCode}`
            this.isShowResult = true
        },
        // 查询国内收寄范围
        async queryInternal() {
            const areaCode = this.addr[this.addr.length - 1].code || ''
            const result = await this.getInternalRange(areaCode)
            if (result) {
                const { unavailableRegions = [], type = '' } = result
                this.resultRange = regionRangeMap.get(type) || '本地区不配送'
                this.unavailableRegions = unavailableRegions
            }
            this.isShowResult = true
        },
        // 关闭选择地区
        closeAreaSelector() {
            this.showAreaSelector = false
        },
        // 点击确认地区
        confirm(selectData) {
            this.showAreaSelector = false
            this.addr = selectData.selectArea
            this.tabCode = selectData.selectTabCode
            this.isShowResult = false
        },
        // 打开地区选择器
        selectAddress() {
            this.showAreaSelector = true
        },
        // 获取国内收寄范围
        getInternalRange(areaCode) {
            return new Promise(resolve => {
                ajax.getInternalRange({
                    params: {
                        areaCode
                    }
                })
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(() => {
                        resolve('')
                    })
            })
        },
        // 获取国际的邮编信息，用于判断是否在收寄范围内
        queryPostCodeInfo(country, postCode) {
            return new Promise(resolve => {
                ajax.queryPostCodeInfo({
                    params: {
                        countryCode: country.rateCode,
                        countryName: country.name,
                        postCode,
                        queryMode: 1
                    }
                })
                    .then(res => {
                        resolve(res.data)
                    })
                    .catch(() => {
                        resolve('')
                    })
            })
        },
        ...mapMutations({
            setTitle: 'setTitle',
            setShowHeader: 'setShowHeader',
            setShowFooter: 'setShowFooter'
        })
    }
}
</script>

<style lang="scss" scoped>
.receiveRange-page {
    background: $gray-lighter;
    padding-top: 0.05rem;
    margin-bottom: 20px;
    .address,
    .result {
        margin: 0.24rem;
        display: flex;
        flex-direction: column;
        background: $white;
        border-radius: 0.08rem;
        box-shadow: 0 0.04rem 0.32rem 0 rgba(0, 0, 0, 0.08);
        position: relative;
        .address-wrap {
            height: 1.25rem;
            padding: 0.2rem 0.2rem 0.2rem 0.6rem;
            position: relative;
            display: flex;
            align-items: center;
            div {
                display: inline-flex;
                font-size: 0.28rem;
                &.holder {
                    margin-right: 0.2rem;
                    flex: 0 0 auto;
                    color: #666;
                }
                &.area {
                    font-size: 0.32rem;
                    color: #999;
                    &.active {
                        color: black;
                    }
                }
            }
            input {
                font-size: 0.32rem;
                padding: 0;
                border-bottom: none;
            }
            &:first-of-type {
                border-bottom: 0.02rem solid $gray-lighter;
            }
            .ico {
                flex: 1;
                display: flex;
                justify-content: flex-end;
                color: black;
                .ico-right {
                    height: 0.4rem;
                }
            }
        }
        .result-item {
            min-height: 1.25rem;
            padding: 0.2rem 0.2rem 0.2rem 0.6rem;
            font-size: 0.3rem;
            color: black;
            .result-area {
                font-size: 0.36rem;
            }
            .supplement {
                color: $gray;
            }
            .red {
                color: $red;
            }
        }
    }
    .warn-tip {
        font-size: 0.28rem;
        padding: 20px 10px;
        color: #dc1e32;
    }
    .button-wrapper {
        text-align: center;
        margin-top: 0.4rem;
        .primary-btn {
            font-weight: bold;
            height: 0.86rem;
            width: 4rem;
            min-width: 4rem;
            line-height: 0.86rem;
            letter-spacing: 1px;
            background-color: #dc1e32;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/receive-range/index.vue